// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ig7K","requiredAsterisk":"Info_requiredAsterisk__nbhFD"};